/* eslint-disable no-unused-vars */
import React, { useEffect, ReactNode } from 'react';
import SideBar from '../component/molecule/common/SideBar';
import RightPanel from '../component/molecule/common/RightPanel';
import { CallForAuth, CallWithAuth } from '../action/apiActions';
import { GET_AUTHENTICATION, POST_REFRESH_AUTH } from '../action/apiPath';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
// import apm from '../apm.config';
import { useSelector } from 'react-redux';
import Loader from '../component/loader';

// Define more specific types for API responses
interface ApiResponse {
  status: boolean;
  res: {
    status: number;
    data: {
      jwt?: string;
    };
  };
}

interface AuthLayoutProps {
  children: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const loader = useSelector((state: any) => state.GetAllData.loader);
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      // apm.setCustomContext({
      //   url: error.config?.url,
      //   method: error.config?.method,
      //   user_id: JSON.parse(localStorage.getItem('userInfo') ?? '{}')?.id ?? '',
      //   feature: 'API Error',
      // });
      // apm.captureError(error);
      if (error.response?.status === 401 && !originalRequest._retry) {
        originalRequest._retry = true; // Prevent infinite loops
        if (error.config.url.includes('refresh')) {
          localStorage.clear();
          sessionStorage.clear();
          axios.defaults.headers.common['Authorization'] = '';
          navigate('/sign-in');
          return;
        }
        await CheckAuthwithRefresh(); // Refresh token
        const userInfo = localStorage?.getItem('userInfo');
        const jwt = userInfo ? JSON.parse(userInfo).jwt : '';
        // Update the Authorization header with the new token
        originalRequest.headers['Authorization'] = `jwt ${jwt}`;

        return axios(originalRequest); // Retry the original request
      }

      return Promise.reject(error);
    }
  );

  // Track page navigation
  // useEffect(() => {
  //   console.log(location.pathname, 'location');
  //   const transaction = apm.startTransaction(`Page View: ${location.pathname}`, 'page-load');
  //   return () => {
  //     transaction?.end();
  //   };
  // }, [location.pathname]); // Runs on route change

  // Track user interactions (clicks & keystrokes)
  // useEffect(() => {
  //   const logInteraction = (event: MouseEvent | KeyboardEvent) => {
  //     apm.addLabels({
  //       event_type: event.type,
  //       element: (event.target as HTMLElement)?.tagName,
  //       page: location.pathname,
  //     });
  //   };

  //   document.addEventListener('click', logInteraction);
  //   document.addEventListener('keydown', logInteraction);

  //   return () => {
  //     document.removeEventListener('click', logInteraction);
  //     document.removeEventListener('keydown', logInteraction);
  //   };
  // }, [location.pathname]); // Updates on every page change

  // Set user context on mount
  // useEffect(() => {
  //   const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
  //   apm.setUserContext({
  //     id: userInfo.id ?? 'anonymous',
  //     username: userInfo.name ?? '',
  //     email: userInfo.email ?? '',
  //   });
  // }, []);

  // call refresh API to get JWT and store in cookies
  const CheckAuthwithRefresh = async (): Promise<void> => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
    const refreshToken = userInfo.jwt_refresh[0];
    const response = (await CallForAuth(`jwt ${refreshToken}`, 'POST', POST_REFRESH_AUTH)) as ApiResponse;
    if (response?.status && response?.res?.data?.jwt) {
      Cookies.set('accessToken', response.res.data.jwt);
      const userInfoString = localStorage.getItem('userInfo');
      if (!userInfoString) {
        // eslint-disable-next-line no-console
        console.error('No userInfo found in localStorage.');
      } else {
        try {
          const userInfo = JSON.parse(userInfoString);
          const newJwtValue = response.res.data.jwt;
          userInfo.jwt = newJwtValue;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          // eslint-disable-next-line no-console
          console.log('JWT updated successfully in localStorage.');
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Error updating JWT in userInfo:', error);
        }
      }
    } else {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
        if (userInfo.hasOwnProperty('jwt')) {
          delete userInfo.jwt;
          // eslint-disable-next-line no-console
          console.log('jwt property has been removed from userInfo.');
        } else {
          // eslint-disable-next-line no-console
          console.warn('jwt property does not exist in userInfo.');
        }
        const updatedUserInfoString = JSON.stringify(userInfo);
        localStorage.setItem('userInfo', updatedUserInfoString);
        // eslint-disable-next-line no-console
        console.log('userInfo updated successfully in localStorage.');
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error processing userInfo:', error);
      }
      navigate('/sign-in');
    }
  };
  //  check that user is authenticated with(  ME API ) or not-> if not the call refresh API
  const THROTTLE_TIME = 10 * 60 * 1000; // 5 minutes

  const CheckAuthwithoutRefresh = async (): Promise<void> => {
    const now = Date.now();
    const lastApiCallTime = parseInt(localStorage.getItem('lastAuthCheck') ?? '0', 10);
    if (!isNaN(lastApiCallTime) && now - lastApiCallTime < THROTTLE_TIME) {
      return;
    }

    localStorage.setItem('lastAuthCheck', now.toString());

    const response = (await CallWithAuth('GET', GET_AUTHENTICATION)) as ApiResponse;

    if (!response?.status && response?.res?.status === 401) {
      await CheckAuthwithRefresh();
    }
  };
  const userInfo = localStorage?.getItem('userInfo');
  const jwt = userInfo ? JSON.parse(userInfo).jwt : '';
  useEffect(() => {
    CheckAuthwithoutRefresh();
  }, []);
  useEffect(() => {
    axios.defaults.headers.common['Authorization'] = `jwt ${jwt ?? Cookies.get('accessToken')}`;
  }, [localStorage?.getItem('userInfo')]);

  return (
    <section id="dashboard">
      {loader && <Loader />}
      <div>
        <SideBar sidebarshow={false} />
        <RightPanel rightbarshow={false}>{children}</RightPanel>
      </div>
    </section>
  );
};

export default AuthLayout;
